var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$1
};

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$2 = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.10.2',
  mode:  'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function (it, metadata) {
    if (wmhas.call(store$1, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (has(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
var getInternalState = internalState.get;
var enforceInternalState = internalState.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global_1) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});
});

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$1(resolve);
  this.reject = aFunction$1(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
var f$5 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability = {
	f: f$5
};

var perform = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var engineIsNode = classofRaw(global_1.process) == 'process';

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process$1 = global_1.process;
var versions = process$1 && process$1.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // eslint-disable-next-line es/no-symbol -- required for testing
  return !Symbol.sham &&
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    (engineIsNode ? engineV8Version === 38 : engineV8Version > 37 && engineV8Version < 41);
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = nativeSymbol
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (nativeSymbol && has(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var iterators = {};

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var ITERATOR$1 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$1]
    || it['@@iterator']
    || iterators[classof(it)];
};

var iteratorClose = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
_export({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
_export({ target: 'Promise', stat: true }, {
  any: function any(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction$1(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        errors.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

/* eslint-disable no-proto -- safe */



// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
_export({ target: 'Object', stat: true }, {
  setPrototypeOf: objectSetPrototypeOf
});

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

var html = getBuiltIn('document', 'documentElement');

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
_export({ target: 'Object', stat: true, sham: !descriptors }, {
  create: objectCreate
});

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
_export({ target: 'Object', stat: true, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod$1(7)
};

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;


var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
}

var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max$1 = Math.max;
var min$2 = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$2(max$1(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

var UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

var BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
	UNSUPPORTED_Y: UNSUPPORTED_Y,
	BROKEN_CARET: BROKEN_CARET
};

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.UNSUPPORTED_Y || regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
// eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

// TODO: Remove from `core-js@4` since it's moved to entry points






var SPECIES$2 = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$2] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === RegExp.prototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classofRaw(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

// @@match logic
fixRegexpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regexpExecAbstract(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
var functionBind = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction$1(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
_export({ target: 'Function', proto: true }, {
  bind: functionBind
});

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
_export({ target: 'Object', stat: true, forced: !descriptors, sham: !descriptors }, {
  defineProperties: objectDefineProperties
});

var freezing = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

var internalMetadata = createCommonjsModule(function (module) {
var defineProperty = objectDefineProperty.f;



var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (freezing && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;
});
var internalMetadata_1 = internalMetadata.REQUIRED;
var internalMetadata_2 = internalMetadata.fastKey;
var internalMetadata_3 = internalMetadata.getWeakData;
var internalMetadata_4 = internalMetadata.onFreeze;

var onFreeze = internalMetadata.onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES$1 = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$1, sham: !freezing }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});

/* eslint-disable es/no-array-prototype-indexof -- required for testing */

var $indexOf = arrayIncludes.indexOf;


var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD$1 = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD$1 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;


var FAILS_ON_PRIMITIVES$2 = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !descriptors || FAILS_ON_PRIMITIVES$2;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
_export({ target: 'Object', stat: true, forced: FORCED, sham: !descriptors }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
_export({ target: 'Object', stat: true, forced: !descriptors, sham: !descriptors }, {
  defineProperty: objectDefineProperty.f
});

/*!
* @bridge/bytedance v2.3.7
* (c) 2024 
*/
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};

/*!
* @bridge/base v2.1.1
* (c) 2022 
*/
var version$1 = "2.1.1";

/**
 * 类型：函数调用错误码
 */
var ErrorCode;
(function (ErrorCode) {
  ErrorCode[ErrorCode["Failure"] = 0] = "Failure";
  ErrorCode[ErrorCode["Success"] = 1] = "Success";
  ErrorCode[ErrorCode["Unauthorized"] = -1] = "Unauthorized";
  ErrorCode[ErrorCode["NotExist"] = -2] = "NotExist"; // 接口不存在
})(ErrorCode || (ErrorCode = {}));
/**
 * 发送方法调用消息的iframe id
 */
var DISPATCH_MESSAGE_IFRAME_ID = '__JSBridgeIframe__';
/**
 * 发送方法调用队列的iframe id
 */
var SET_RESULT_IFRAME_ID = '__JSBridgeIframe_SetResult__';
/**
 * 回调函数ID计数起点
 * PIA Wroker计数起点差异化，背景 https://bytedance.feishu.cn/docx/doxcnGvSgtSzoOvbiPS1wdZRKNg
 */
var CALLBACK_ID_START = typeof __PIA_WORKER__ === "undefined" ? 1023 : 1023e5;
/**
 * 默认的JSSDK版本号
 */
var DEFAULT_VERSION = version$1;
/**
 * iframe调用的默认scheme
 */
var DEFAULT_SCHEME = 'nativeapp://';
/**
 * iframe调用的默认消息发送路径
 */
var DEFAULT_DISPATCH_MESSAGE_PATH = 'dispatch_message/';
/**
 * iframe调用的默认结果发送路径
 */
var DEFAULT_SET_RESULT_PATH = 'private/setresult/SCENE_FETCHQUEUE';
var JSBridge = /** @class */function () {
  function JSBridge(options) {
    this.version = options.version || DEFAULT_VERSION;
    this.nativeMethodInvoker = options.nativeMethodInvoker;
    this.nativeEventListener = options.nativeEventListener;
    this.scheme = options.scheme || DEFAULT_SCHEME;
    this.dispatchMessagePath = options.dispatchMessagePath || DEFAULT_DISPATCH_MESSAGE_PATH;
    this.setResultPath = options.setResultPath || DEFAULT_SET_RESULT_PATH;
    this.dispatchMessageIFrameId = options.dispatchMessageIFrameId || DISPATCH_MESSAGE_IFRAME_ID;
    this.setResultIFrameId = options.setResultIFrameId || SET_RESULT_IFRAME_ID;
    this.listenNativeEvent = options.listenNativeEvent === true ? true : false;
    this.callbackId = CALLBACK_ID_START;
    this.callbackMap = {};
    this.eventMap = {};
    this.javascriptMessageQueue = [];
    this.callbackProcessor = options.callbackProcessor;
  }
  /**
   * 设置业务应用ID
   * @param appID
   * @returns
   */
  JSBridge.prototype.setAppID = function (appID) {
    this.appID = appID;
    return;
  };
  /**
   * 调用客户端方法
   *
   * @param func - 函数名称
   * @param params - 参数
   * @param callback - 回调函数
   * @param sdkVersion - JSSDK版本号
   */
  JSBridge.prototype.call = function (func, params, callback, options) {
    if (options === void 0) {
      options = this.version;
    }
    var sdkVersion = this.version;
    var namespace;
    var appID = this.appID;
    if (!func || typeof func !== 'string') {
      return;
    }
    if (typeof params !== 'object') {
      params = {};
    }
    if (typeof options === 'string') {
      sdkVersion = options || this.version;
    } else if (typeof options === 'object') {
      namespace = options.namespace;
      sdkVersion = options.sdkVersion || this.version;
      appID = options.appID || this.appID;
    }
    var message = {
      func: func,
      params: params,
      // @ts-ignore
      JSSDK: sdkVersion,
      __msg_type: 'call',
      namespace: namespace,
      appID: appID
    };
    if (typeof callback === 'function' || callback === undefined) {
      var callbackId = this.registerCallback(func, callback);
      message.__callback_id = callbackId;
    }
    if (typeof __PIA_WORKER__ === "undefined" && window.parent !== window) {
      // 说明sdk是在iframe内部被引用
      // 客户端侧可通过这个属性判断是否在iframe内部使用jsb，从而做相应的处理
      // 背景见：https://bytedance.feishu.cn/docs/doccnytoP4lXehQWqvQGsQdZMsb
      message.__iframe_url = window.location.href;
    }
    this.sendMessageToNative(message);
  };
  /**
   * 注册事件监听器
   *
   * @param event - 事件名称
   * @param callback - 回调函数
   * @return - 回调ID
   */
  JSBridge.prototype.on = function (event, callback, once) {
    if (once === void 0) {
      once = false;
    }
    if (!event || typeof event !== 'string' || typeof callback !== 'function') {
      return;
    }
    var callbackId = this.registerCallback(event, callback);
    this.eventMap[event] = this.eventMap[event] || {};
    this.eventMap[event][callbackId] = {
      once: once
    };
    // 兼容旧版SDK
    if (this.listenNativeEvent) {
      if (this.nativeEventListener) {
        this.nativeEventListener(event);
      } else {
        // const eventMessage: JavaScriptMessage = {
        //     func: event,
        //     params: {},
        //     JSSDK: this.version,
        //     __msg_type: 'event',
        //     __callback_id: event,
        // };
        // this.sendMessageToNative(eventMessage);
        // 尝试兼容旧版方案
        this.call('addEventListener', {
          name: event
        }, null, {
          sdkVersion: 1
        });
      }
    }
    return callbackId;
  };
  /**
   * 注册单次事件监听器
   *
   * @param event - 事件名称
   * @param callback - 回调函数
   * @return - 回调ID
   */
  JSBridge.prototype.once = function (event, callback) {
    return this.on(event, callback, true);
  };
  /**
   * 注销事件监听器
   *
   * @param event - 事件名称
   * @param callbackId - 回调ID
   * @return - 注销结果
   */
  JSBridge.prototype.off = function (event, callbackId) {
    if (!event || typeof event !== 'string') {
      return true;
    }
    var callbackMetaMap = this.eventMap[event];
    if (!callbackMetaMap || typeof callbackMetaMap !== 'object' || !callbackMetaMap.hasOwnProperty(callbackId)) {
      return true;
    }
    this.deregisterCallback(callbackId);
    delete callbackMetaMap[callbackId];
    return true;
  };
  /**
   * 模拟客户端触发事件
   *
   * @param event - 事件名称
   * @param params - 事件参数
   */
  JSBridge.prototype.trigger = function (event, params) {
    return this.handleMessageFromNative({
      __msg_type: 'event',
      __params: params,
      __event_id: event
    });
  };
  /**
   * 处理客户端发送过来的消息
   *
   * @param message - 客户端消息
   */
  JSBridge.prototype.handleMessageFromNative = function (message) {
    var _this = this;
    var data = message;
    var callbackId = String(data.__callback_id);
    // [DMT + 直播 + 火山] iOS 的 JSB 3.0 比 Android 多了一层 data, 需要判断是否取出 data (XBridge 例外)
    // 所有 event 则都需要取出 data: https://bytedance.feishu.cn/docs/doccnznNw1IQCHH2GldPI7L70Oh#vW6TkD
    if (this.callbackProcessor && typeof this.callbackProcessor === 'function') {
      // 这里取调用的 JSB 名称用于判断是否 XBridge
      var method = (this.callbackMap && this.callbackMap[callbackId] || {}).method;
      this.callbackProcessor(data, method);
    }
    var params = data.__params;
    // 兼容老版本逻辑，默认设置为''(处理undefined的情况)
    var event = String(data.__event_id || '');
    var messageType = data.__msg_type;
    // 某些app事件消息返回的__msg_type也是callback，所以不要依赖__msg_type来判断是什么类型
    if (this.callbackMap[callbackId]) {
      messageType = 'callback';
    } else if (this.eventMap[callbackId]) {
      messageType = 'event';
      // 兼容西瓜 只返回 __callback_id
      event = event || callbackId;
    }
    var ret = {
      __err_code: 'cb404'
    };
    switch (messageType) {
      case 'callback':
        var callback = (this.callbackMap && this.callbackMap[callbackId] || {}).callback;
        if (typeof callback === 'function') {
          ret = callback(params);
        }
        this.deregisterCallback(callbackId);
        break;
      case 'event':
        var callbackMetaMap_1 = this.eventMap[event];
        if (callbackMetaMap_1 && typeof callbackMetaMap_1 === 'object') {
          Object.keys(callbackMetaMap_1).forEach(function (callbackId) {
            var callback = (_this.callbackMap && _this.callbackMap[callbackId] || {}).callback;
            var callbackMeta = callbackMetaMap_1[callbackId];
            if (typeof callback === 'function') {
              ret = callback(params);
            }
            if (callbackMeta && callbackMeta.once) {
              _this.deregisterCallback(callbackId);
              delete callbackMetaMap_1[callbackId];
            }
          });
        }
        break;
    }
    /**
     * 在某些场景下，客户端根据返回值来判断
     * 客户端的消息是否成功发送到H5端
     */
    return ret;
  };
  /**
   * 拉取JavaScript消息队列
   */
  JSBridge.prototype.fetchJavaScriptMessageQueue = function () {
    var json = JSON.stringify(this.javascriptMessageQueue);
    /**
     * android 4.4以下版本客户端通过result iframe获取消息队列内容
     *
     * 为什么base64编码前需要执行`unescape(encodeURIComponent(json))`？
     * 详情参考：https://developer.mozilla.org/zh-CN/docs/Web/API/WindowBase64/btoa#Unicode_%E5%AD%97%E7%AC%A6%E4%B8%B2
     */
    var base64 = btoa(unescape(encodeURIComponent(json)));
    if (this.setResultIFrame && this.javascriptMessageQueue.length > 0) {
      this.setResultIFrame.src = "" + this.scheme + this.setResultPath + "&" + base64;
    }
    // 清空javascript消息队列
    this.javascriptMessageQueue.splice(0, this.javascriptMessageQueue.length);
    /**
     * ios以及android 4.4以上版本客户端
     * 直接通过函数返回值获取消息队列内容
     */
    return json;
  };
  /**
   * 发送消息到客户端
   *
   * @param message JavaScript端的消息结构
   */
  JSBridge.prototype.sendMessageToNative = function (message) {
    /**
     * 在编写注入式调用和iframe式调用的性能对比测试时，需要提供一个机制
     * 主动触发iframe式调用，因此这里增加了一个判断条件message.JSSDK，
     * 调用方法时sdkVersion传入空字符串即可触发iframe调用。
     */
    if (String(message.JSSDK) !== "1" && this.nativeMethodInvoker) {
      var nativeMessageJSON = this.nativeMethodInvoker(message);
      /**
       * 如果该方法有返回，说明客户端采用了同步调用方式
       */
      if (nativeMessageJSON) {
        var nativeMessage = JSON.parse(nativeMessageJSON);
        this.handleMessageFromNative(nativeMessage);
      }
    } else {
      // 如果没有检测到注入的全局API，则fallback到iframe发起调用的方式
      this.javascriptMessageQueue.push(message);
      if (!this.dispatchMessageIFrame) {
        this.tryCreateIFrames();
      }
      this.dispatchMessageIFrame.src = "" + this.scheme + this.dispatchMessagePath;
    }
  };
  /**
   * 注册回调函数
   *
   * @param method - 调用方法 / 事件
   * @param callback - 回调函数
   * @return - 回调ID
   */
  JSBridge.prototype.registerCallback = function (method, callback) {
    var callbackId = String(this.callbackId++);
    this.callbackMap[callbackId] = {
      method: method,
      callback: callback
    };
    return callbackId;
  };
  /**
   * 注销回调函数
   *
   * @param callbackId - 回调函数ID
   */
  JSBridge.prototype.deregisterCallback = function (callbackId) {
    delete this.callbackMap[callbackId];
  };
  /**
   * 尝试创建需要用到的两个iframe
   */
  JSBridge.prototype.tryCreateIFrames = function () {
    this.dispatchMessageIFrame = this.createIFrame(this.dispatchMessageIFrameId);
    this.setResultIFrame = this.createIFrame(this.setResultIFrameId);
    return;
  };
  /**
   * 创建iframe，用于向客户端发送消息
   *
   * @param id - iframe元素id
   * @return - iframe元素
   */
  JSBridge.prototype.createIFrame = function (id) {
    var iframe = document.getElementById(id);
    if (!iframe || iframe.tagName !== 'IFRAME') {
      iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.id = id;
      document.documentElement.appendChild(iframe);
    }
    return iframe;
  };
  return JSBridge;
}();
var version$2 = "2.3.7";
var global$1 = typeof __PIA_WORKER__ !== 'undefined' ? new Function('return this')() : typeof window !== 'undefined' ? window : {}; // 兼容ssr
var userAgent = typeof global$1 !== 'undefined' && global$1.navigator ? global$1.navigator.userAgent : ''; // 兼容ssr
// ua 判断是否为头条方案
// newsarticle：头条
// videoarticle：西瓜
// super：皮皮虾 （super_lite和super_pro）
// lv: 剪映
// faceu：Faceu
// ulike ｜ beauty_me_: 轻颜
// faceu-os：faceu(海外版)
// ulike-os或beauty_me_oversea_：轻颜海外版
// retouch：T项目
// automobile：懂车帝
// 新版轻颜判断为不是头条环境。
// 如果是直播环境则判断为不是头条环境。
var isToutiaoEnvironment = (!!userAgent.match(/(newsarticle|videoarticle|lv|faceu|ulike|beauty_me_|faceu-os|ulike-os|beauty_me_oversea_|retouch|homed)\/([\d.]+)/i) || /super|automobile/gi.test(userAgent)) && !/webcast/gi.test(userAgent) && !/luckycatversion/gi.test(userAgent) && !/beauty\/([\d.]+)/gi.test(userAgent);
// 处理faceu国内版问题：国内既有拦截也有注入方式，但是拦截方式没有回调
// 游戏中台webview只使用了2.0的jsb，如果通过函数名判断是否使用1.0，会导致native调js失效
// 2021/10/26 新增 PIANativeWorker, PIA 只使用注入
// 2023/1/8 新增beauty ，新版轻颜h5只是用注入
var useInjection = !!userAgent.match(/(faceu)\/([\d.]+)/i) || !!userAgent.match(/homed/gi) || /gsdk/gi.test(userAgent) || /PIANativeWorker/gi.test(userAgent) || /beauty\/([\d.]+)/gi.test(userAgent);
// 旧广告webview sdk的实现，必须使用iframe方式且schema为bytedance
// https://bytedance.feishu.cn/wiki/wikcnG3BE7Wr5MZ4hUFL187M9nd @maintainer：zhangyu.paul@bytedance.com
var isLegacyAdEnvironment = !!userAgent.match(/ttad\/0/i);
// 新增 Phoenix TikTokNow Alligator
var isDMT = !!userAgent.match(/aweme|trill|musical_ly|phoenix_\d+|TikTokNow_\d+|alligatortiktok/i);
var isHotsoon = !!userAgent.match(/live_stream/i);
var isWebcast = !!userAgent.match(/Webcast/i);
var isPipixia = !!userAgent.match(/super/i);
var isDoulaike = !!userAgent.match(/life_service_merchant/i);
var isDeliverer = !!userAgent.match(/deliverer/i);
var isXiaoBang = !!userAgent.match(/xiaobang/i);
// 皮皮虾特殊逻辑，皮皮虾可能使用1.0的协议向客户端发送事件，客户端回调时用的是3.0的对象，🤮
var useOldSchemeAndGlobalVariable = /super/gi.test(userAgent) || /homed/gi.test(userAgent);

/**
 * 探测客户端注入的调用API
 */
function detectNativeMethodInvoker() {
  var nativeMethodInvoker;
  if (global$1.JS2NativeBridge && global$1.JS2NativeBridge._invokeMethod) {
    // 标准实现
    nativeMethodInvoker = function nativeMethodInvoker(message) {
      return global$1.JS2NativeBridge._invokeMethod(JSON.stringify(message));
    };
  } else if (global$1.ToutiaoJSBridge && global$1.ToutiaoJSBridge.invokeMethod) {
    // 融合前IES的实现
    nativeMethodInvoker = function nativeMethodInvoker(message) {
      return global$1.ToutiaoJSBridge.invokeMethod(JSON.stringify(message));
    };
  } else if (global$1.JS2NativeBridge && global$1.JS2NativeBridge.call) {
    // 融合前头条的安卓实现
    nativeMethodInvoker = function nativeMethodInvoker(message) {
      return global$1.JS2NativeBridge.call(message.func, JSON.stringify(message));
    };
  } else if (global$1.webkit && global$1.webkit.messageHandlers && global$1.webkit.messageHandlers.callMethodParams) {
    // 融合前头条的iOS WkWebview实现
    nativeMethodInvoker = function nativeMethodInvoker(message) {
      global$1.webkit.messageHandlers.callMethodParams.postMessage(message);
      // iOS 14 postMessage返回的是promise
      return;
    };
  } else if (global$1.callMethodParams) {
    // 融合前头条的iOS UIWebview实现
    nativeMethodInvoker = function nativeMethodInvoker(message) {
      return global$1.callMethodParams(message.func, message);
    };
  } else if (global$1.HomedJSBridge && global$1.HomedJSBridge.invokeMethod) {
    // 住小帮业务实现
    nativeMethodInvoker = function nativeMethodInvoker(message) {
      return global$1.HomedJSBridge.invokeMethod(JSON.stringify(message));
    };
  }
  return nativeMethodInvoker;
}
/**
 * 探测客户端注入的事件监听器
 */
function detectNativeEventListener() {
  if (!isToutiaoEnvironment) {
    return;
  }
  var nativeEventListener;
  if (global$1.JSBridge && global$1.JSBridge.on) {
    // 标准实现
    nativeEventListener = global$1.JSBridge.on;
  } else if (global$1.JS2NativeBridge && global$1.JS2NativeBridge.on) {
    // 融合前头条的安卓实现
    nativeEventListener = function nativeEventListener(event) {
      var eventMessage = {
        JSSDK: version$2,
        __msg_type: 'event',
        __callback_id: event,
        func: event
      };
      global$1.JS2NativeBridge.on(event, JSON.stringify(eventMessage));
    };
  } else if (global$1.webkit && global$1.webkit.messageHandlers && global$1.webkit.messageHandlers.onMethodParams) {
    // 融合前头条的iOS WkWebview实现
    nativeEventListener = function nativeEventListener(event) {
      var eventMessage = {
        JSSDK: version$2,
        __msg_type: 'event',
        __callback_id: event,
        func: event
      };
      global$1.webkit.messageHandlers.onMethodParams.postMessage(eventMessage);
    };
  } else if (global$1.onMethodParams) {
    // 融合前头条的iOS UIWebview实现
    nativeEventListener = function nativeEventListener(event) {
      var eventMessage = {
        JSSDK: version$2,
        __msg_type: 'event',
        __callback_id: event,
        func: event
      };
      return global$1.onMethodParams(event, eventMessage);
    };
  }
  return nativeEventListener;
}
/**
 * 探测客户端支持的scheme
 */
function detectScheme() {
  if (isPipixia) {
    return 'bds://';
  }
  if (useOldSchemeAndGlobalVariable) {
    return 'bytedance://';
  }
  if (isToutiaoEnvironment) {
    return 'nativeapp://';
  }
  if (global$1.JSBridge && global$1.JSBridge._invokeMethod) {
    return 'nativeapp://';
  }
  return 'bytedance://';
}
function callbackProcessor(message, method) {
  // x-bridge 方法不做预处理
  if (typeof method === 'string' && true === /^(x|tc)\./.test(method)) {
    return;
  }
  if (isDMT || isHotsoon || isWebcast || isDoulaike || isXiaoBang || isDeliverer) {
    var params = message.__params;
    if (global$1.JS2NativeBridge && global$1.JS2NativeBridge._invokeMethod) {
      message.__params = _assign({
        code: params.code
      }, params.data);
    }
  }
}

/**
 * 头条旧版本JSBridge实现（只针对头条旧版本App使用）
 */
var ToutiaoJSBridge = /** @class */function (_super) {
  __extends(ToutiaoJSBridge, _super);
  // 这里需要改写iframe的id
  // 同时使用1.0和2.0时，如果不区分iframe，那么会同步修改同一个iframe的src，webview只会拦截最后修改的src
  function ToutiaoJSBridge() {
    var _this = _super.call(this, {
      version: version$2,
      scheme: 'bytedance://',
      listenNativeEvent: true,
      dispatchMessageIFrameId: '__JSBridgeIframe_1.0__',
      setResultIFrameId: '__JSBridgeIframe_SetResult_1.0__',
      nativeEventListener: detectNativeEventListener(),
      callbackProcessor: callbackProcessor
    }) || this;
    _this.publicApi = {
      call: _this.call.bind(_this),
      on: _this.on.bind(_this),
      once: _this.once.bind(_this),
      off: _this.off.bind(_this),
      trigger: _this.trigger.bind(_this),
      setAppID: _this.setAppID.bind(_this),
      _fetchQueue: _this.fetchJavaScriptMessageQueue.bind(_this),
      _handleMessageFromToutiao: _this.handleMessageFromNative.bind(_this)
    };
    return _this;
  }
  ToutiaoJSBridge.prototype.exposePublicApiToGlobal = function () {
    global$1.ToutiaoJSBridge = Object.assign(global$1.ToutiaoJSBridge || {}, this.publicApi);
  };
  return ToutiaoJSBridge;
}(JSBridge);

/**
 * 融合后的JSBridge（IES所有版本App可用，头条新版App可用）
 */
var BytedanceJSBridge = /** @class */function (_super) {
  __extends(BytedanceJSBridge, _super);
  function BytedanceJSBridge(toutiaoJSBridge) {
    var _this = _super.call(this, {
      version: version$2,
      nativeMethodInvoker: detectNativeMethodInvoker(),
      nativeEventListener: detectNativeEventListener(),
      scheme: detectScheme(),
      listenNativeEvent: isToutiaoEnvironment,
      callbackProcessor: callbackProcessor
    }) || this;
    _this.toutiaoLegacyJSB = toutiaoJSBridge;
    _this.publicApi = {
      call: _this.call.bind(_this),
      on: _this.on.bind(_this),
      once: _this.once.bind(_this),
      off: _this.off.bind(_this),
      trigger: _this.trigger.bind(_this),
      setAppID: _this.setAppID.bind(_this),
      _fetchQueue: _this.fetchJavaScriptMessageQueue.bind(_this),
      _handleMessageFromApp: _this.handleMessageFromNative.bind(_this),
      _handleMessageFromToutiao: _this.handleMessageFromNative.bind(_this)
    };
    return _this;
  }
  /**
   * 调用客户端方法
   *
   * @param func - 函数名称
   * @param params - 参数
   * @param callback - 回调函数
   * @param options - JSSDK版本号 或者 option配置: {sdkVersion,namespace}
   */
  BytedanceJSBridge.prototype.call = function (func, params, callback, options) {
    if (options === void 0) {
      options = version$2;
    }
    if (this.isLegacyCall(func)) {
      this.toutiaoLegacyJSB.call(func, params, callback, options);
    } else {
      _super.prototype.call.call(this, func, params, callback, options);
    }
  };
  /**
   * 注册事件监听器
   *
   * @param event - 事件名称
   * @param callback - 回调函数
   * @param options - 调用配置
   * @return - 回调ID
   */
  BytedanceJSBridge.prototype.on = function (event, callback, once, options) {
    if (once === void 0) {
      once = false;
    }
    var useLegacy = (options || {}).useLegacy;
    // 提供调用选项，如果指定使用3.0协议则无视事件名判断
    if (useLegacy || this.isLegacyCall(event)) {
      return this.toutiaoLegacyJSB.on(event, callback, once);
    } else {
      return _super.prototype.on.call(this, event, callback, once);
    }
  };
  /**
   * 注册单次事件监听器
   *
   * @param event - 事件名称
   * @param callback - 回调函数
   * @return - 回调ID
   */
  BytedanceJSBridge.prototype.once = function (event, callback) {
    if (this.isLegacyCall(event)) {
      return this.toutiaoLegacyJSB.once(event, callback);
    } else {
      return _super.prototype.once.call(this, event, callback);
    }
  };
  /**
   * 注销事件监听器
   *
   * @param event - 事件名称
   * @param callbackId - 回调ID
   * @return - 注销结果
   */
  BytedanceJSBridge.prototype.off = function (event, callbackId) {
    if (this.isLegacyCall(event)) {
      return this.toutiaoLegacyJSB.off(event, callbackId);
    } else {
      return _super.prototype.off.call(this, event, callbackId);
    }
  };
  /**
   * 模拟客户端触发事件
   *
   * @param event - 事件名称
   * @param params - 事件参数
   */
  BytedanceJSBridge.prototype.trigger = function (event, params) {
    if (this.isLegacyCall(event)) {
      return this.toutiaoLegacyJSB.trigger(event, params);
    } else {
      return _super.prototype.trigger.call(this, event, params);
    }
  };
  /**
   * 设置业务应用 ID
   * @param appID
   */
  BytedanceJSBridge.prototype.setAppID = function (appID) {
    if (this.toutiaoLegacyJSB) {
      this.toutiaoLegacyJSB.setAppID(appID);
    }
    _super.prototype.setAppID.call(this, appID);
  };
  BytedanceJSBridge.prototype.exposePublicApiToGlobal = function () {
    var _this = this;
    global$1.JSBridge = Object.assign(global$1.JSBridge || {}, this.publicApi);
    // 兼容那些非头条环境但是使用过2.0协议的app
    // 皮皮虾Android会先后用2.0 1.0的版本拦截schema, 此处不注入Native2JSBridge让2.0的拦截失效
    // 详见 https://bytedance.feishu.cn/docs/doccnOAscnazxsYPyZRlMz5ptOb#
    if (!global$1.__DISABLE_JSB_PROTOCAL2__) {
      global$1.Native2JSBridge = Object.assign(global$1.Native2JSBridge || {}, this.publicApi);
    }
    if (useOldSchemeAndGlobalVariable) {
      global$1.ToutiaoJSBridge = Object.assign(global$1.ToutiaoJSBridge || {}, this.publicApi);
    } else if ((isToutiaoEnvironment || isLegacyAdEnvironment) && this.toutiaoLegacyJSB) {
      this.toutiaoLegacyJSB.exposePublicApiToGlobal();
    } else {
      global$1.ToutiaoJSBridge = Object.assign(global$1.ToutiaoJSBridge || {}, this.publicApi);
    }
    // 支持在iframe中调用，注意：需要放在freeze之前，否则freeze失败就无法执行到
    if (global$1.parent !== global$1 && global$1.addEventListener) {
      global$1.addEventListener("message", function (event) {
        if (event && event.data && event.data.__callback_id) {
          _this.handleMessageFromNative(event.data);
        }
      }, false);
    }
    // 将window下的ToutiaoJSBridge和JSBridge设置成不可写，避免被其他注入的jsb覆盖
    Object.defineProperties(global$1, {
      'JSBridge': {
        writable: false
      },
      'Native2JSBridge': {
        writable: false
      },
      'ToutiaoJSBridge': {
        writable: false
      }
    });
    // 冻结全局JSB对象，防止被改写
    Object.freeze(global$1.JSBridge);
    Object.freeze(global$1.Native2JSBridge);
    Object.freeze(global$1.ToutiaoJSBridge);
  };
  /**
   * 判断是否是头条旧实现，头条新实现方法名都带"."
   *
   * @param func - 函数名称
   */
  BytedanceJSBridge.prototype.isLegacyCall = function (func) {
    if (!func || typeof func !== 'string' || !this.toutiaoLegacyJSB) {
      return false;
    }
    if (isLegacyAdEnvironment) {
      return true;
    }
    if (useInjection || useOldSchemeAndGlobalVariable) {
      return false;
    }
    return isToutiaoEnvironment && func.indexOf('.') < 0;
  };
  return BytedanceJSBridge;
}(JSBridge);

/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */

function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }
  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }
    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}
function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}
var es6ObjectAssign = {
  assign: assign,
  polyfill: polyfill
};

/**
 * Eden目前不支持自动添加polyfill, 暂时手动引用
 */
es6ObjectAssign.polyfill();
var toutiaoJSBridge = new ToutiaoJSBridge();
var bytedanceJSBridge = new BytedanceJSBridge(toutiaoJSBridge);
try {
  // 暴露公共Api到全局环境
  bytedanceJSBridge.exposePublicApiToGlobal();
} catch (error) {
  console.warn(error.message);
}

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$3 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var defineProperty$1 = objectDefineProperty.f;
var trim = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = global_1[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classofRaw(objectCreate(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classofRaw(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys$1 = descriptors ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys$1.length > j; j++) {
    if (has(NativeNumber, key = keys$1[j]) && !has(NumberWrapper, key)) {
      defineProperty$1(NumberWrapper, key, getOwnPropertyDescriptor$2(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global_1, NUMBER, NumberWrapper);
}

/**
* 通过 JSBridge 或者 UA 获取当前运行宿主的 ID 与版本号
* @param {object} ctx.jsb  JSBridge API
* @param {function} callback  回调函数, 把执行结果传入其中
*/
function getRuntimeEnv(ctx, callback) {
  ctx.jsb.call('app.getAppInfo', {}, function (data) {
    if ('data' in data) {
      data = data.data;
    }
    if (!data) {
      callback(new Error('[鹊桥 SDK] 环境函数 appInfo 调用失败'));
    }
    var _data = data,
      aid = _data.aid,
      version_code = _data.version_code;
    var envResult = {
      appid: Number(aid),
      version: version_code
    };
    console.log('[鹊桥 SDK] 环境函数运行结果: ', envResult);
    callback(null, envResult);
  });
}

/**
* 鹊桥 SDK 将在 JSBridge 运行时调用此监控函数, 可以在这里进行数据上报
* 使用指南: https://bytedance.feishu.cn/docs/doccnVaE0RgaBgG5VI6QdoLy0ee
*/
function monitor(ctx, jsbInfo) {
  console.log('[鹊桥 SDK Monitor]: ', ctx, jsbInfo);
}

/**
* 回参预处理函数, 使用指南: https://bytedance.feishu.cn/docs/doccnOKov7fNFjs98EF073mhdUd
* @param {object} params  客户端回参
* @param {'ios'|'android'} ctx.env.os  运行系统
* @param {string} ctx.env.version  运行宿主版本
* @param {object} ctx.params  入参
*/
function responseProcess(params, ctx) {
  // 过滤掉 code，业务不关心 code 
  // if (params.data) {
  //   return params.data;
  // } else {
  //   return params;
  // }
  return params;
}

var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return _setPrototypeOf(o, p);
  }
  module.exports = _setPrototypeOf;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(setPrototypeOf);

var inheritsLoose = createCommonjsModule(function (module) {
  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    setPrototypeOf(subClass, superClass);
  }
  module.exports = _inheritsLoose;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _inheritsLoose = unwrapExports(inheritsLoose);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!toStringTagSupport) {
  redefine(Object.prototype, 'toString', objectToString, { unsafe: true });
}

var nativePromiseConstructor = global_1.Promise;

var redefineAll = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};

var defineProperty$2 = objectDefineProperty.f;



var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG$2)) {
    defineProperty$2(it, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var SPECIES$3 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors && Constructor && !Constructor[SPECIES$3]) {
    defineProperty(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var anInstance = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var ITERATOR$2 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var SPECIES$4 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES$4]) == undefined ? defaultConstructor : aFunction$1(S);
};

var engineIsIos = /(?:iphone|ipod|ipad).*applewebkit/i.test(engineUserAgent);

var location = global_1.location;
var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$2 = global_1.process;
var MessageChannel = global_1.MessageChannel;
var Dispatch = global_1.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global_1.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (engineIsNode) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !engineIsIos) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = functionBindContext(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global_1.addEventListener &&
    typeof postMessage == 'function' &&
    !global_1.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global_1.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task = {
  set: set$1,
  clear: clear
};

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent);

var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var macrotask = task.set;




var MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver;
var document$2 = global_1.document;
var process$3 = global_1.process;
var Promise$1 = global_1.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$3(global_1, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (engineIsNode && (parent = process$3.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!engineIsIos && !engineIsNode && !engineIsWebosWebkit && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (engineIsNode) {
    notify = function () {
      process$3.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global_1, flush);
    };
  }
}

var microtask = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var hostReportErrors = function (a, b) {
  var console = global_1.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var task$1 = task.set;











var SPECIES$5 = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = internalState.get;
var setInternalState = internalState.set;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var PromiseConstructor = nativePromiseConstructor;
var TypeError$1 = global_1.TypeError;
var document$3 = global_1.document;
var process$4 = global_1.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability$1 = newPromiseCapability.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var DISPATCH_EVENT = !!(document$3 && document$3.createEvent && global_1.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED$1 = isForced_1(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (engineV8Version === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!engineIsNode && !NATIVE_REJECTION_EVENT) return true;
  }
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (engineV8Version >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$5] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED$1 || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify$1 = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$3.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global_1['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task$1.call(global_1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (engineIsNode) {
          process$4.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = engineIsNode || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task$1.call(global_1, function () {
    var promise = state.facade;
    if (engineIsNode) {
      process$4.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$1(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$1(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction$1(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = engineIsNode ? process$4.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify$1(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if ( typeof nativePromiseConstructor == 'function') {
    nativeThen = nativePromiseConstructor.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(nativePromiseConstructor.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') _export({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars -- required for `.length`
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global_1, arguments));
      }
    });
  }
}

_export({ global: true, wrap: true, forced: FORCED$1 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
_export({ target: PROMISE, stat: true, forced: FORCED$1 }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability$1(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

_export({ target: PROMISE, stat: true, forced:  FORCED$1 }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve( this, x);
  }
});

_export({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!nativePromiseConstructor && fails(function () {
  nativePromiseConstructor.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
_export({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// patch native Promise.prototype for native async functions
if ( typeof nativePromiseConstructor == 'function' && !nativePromiseConstructor.prototype['finally']) {
  redefine(nativePromiseConstructor.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
}

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  objectDefineProperty.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var $find = arrayIteration.find;


var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

var test$1 = [];
var nativeSort = test$1.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD$2 = arrayMethodIsStrict('sort');

var FORCED$2 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$2;

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED$2 }, {
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? nativeSort.call(toObject(this))
      : nativeSort.call(toObject(this), aFunction$1(comparefn));
  }
});

var $map = arrayIteration.map;


var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = DatePrototype[TO_STRING];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine(DatePrototype, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}

/**
 * description: console // 请勿使用此文件能力，将再后续版本移除！
 * author: chenmeng.cm@bytedance.com
 * date: 2021-03-03 14:55:15 +0800
 */

var logger = {
  // lynx不支持function.apply 所以暂时强制用一个参数
  info: function info(p) {
    console.info(p);
  },
  warn: function warn(p) {
    console.warn(p);
  },
  log: function log(p) {
    console.log(p);
  }
};

var TO_STRING$1 = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING$1];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING$1;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING$1, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? regexpFlags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y;
var arrayPush = [].push;
var min$3 = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// @@split logic
fixRegexpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegexp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y$2 ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y$2 ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y$2 ? 0 : q;
        var z = regexpExecAbstract(splitter, UNSUPPORTED_Y$2 ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min$3(toLength(splitter.lastIndex + (UNSUPPORTED_Y$2 ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, UNSUPPORTED_Y$2);

var $filter = arrayIteration.filter;


var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $some = arrayIteration.some;


var STRICT_METHOD$3 = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD$3 }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
_export({ target: 'Array', stat: true }, {
  isArray: isArray
});

var ObjProto = Object.prototype;
var hasOwnProperty$1 = ObjProto.hasOwnProperty,
  toString$1 = ObjProto.toString;
var util = {
  hasOwnProp: function hasOwnProp(obj, prop) {
    if (this.isObject(obj)) {
      return hasOwnProperty$1.call(obj, prop);
    }
    return false;
  },
  isEmpty: function isEmpty(obj) {
    if (obj == null) {
      return true;
    }
    return this.getProLen(obj) === 0;
  },
  getType: function getType(input) {
    return toString$1.call(input).match(/\[object (\w+)\]/)[1];
  },
  getProLen: function getProLen(obj) {
    var len = 0;
    if (this.isObject(obj)) {
      len = Object.keys(obj).length;
    }
    return len;
  },
  verCompare: function verCompare(v1, v2) {
    if (v1 === v2) {
      return 0;
    }
    var v1Arr = v1.toString().split('.');
    var v2Arr = v2.toString().split('.');
    while (v1Arr.length < v2Arr.length) v1Arr.push('0');
    while (v2Arr.length < v1Arr.length) v2Arr.push('0');
    var i = 0;
    while (i < v1Arr.length) {
      var v1Num = Number(v1Arr[i]);
      var v2Num = Number(v2Arr[i]);
      if (v2Num > v1Num) {
        return -1;
      } else if (v2Num < v1Num) {
        return 1;
      }
      i += 1;
    }
    return 0;
  },
  warn: function warn(msg) {
    logger.warn("[via]: " + msg);
  },
  error: function error(msg) {
    logger.warn("[via]: " + msg);
  }
};
['Number', 'Date', 'Object', 'String', 'Function', 'Boolean', 'Null', 'Undefined', 'Array'].forEach(function (type) {
  util["is" + type] = function (input) {
    var result = toString$1.call(input) === "[object " + type + "]";
    return result;
  };
});
function isVersionTargeted(version, targetAppVersion) {
  if (targetAppVersion === undefined || targetAppVersion === '*') {
    return true;
  }
  var rules = String(targetAppVersion).split('|').map(function (rule) {
    var chunks = rule.split('-');
    var r = '';
    switch (chunks.length) {
      case 1:
        r = chunks[0];
        break;
      case 2:
        r = {
          min: chunks[0],
          max: chunks[1]
        };
        break;
    }
    return r;
  }).filter(function (rule) {
    return rule;
  });
  return rules.some(function (rule) {
    if (util.isString(rule)) {
      return rule === version;
    } else if (util.isObject(rule)) {
      var min = rule.min;
      var max = rule.max;
      var b = true;
      if (min) {
        b = b && util.verCompare(version, min) !== -1;
      }
      if (max) {
        b = b && util.verCompare(version, max) !== 1;
      }
      return b;
    }
    return false;
  });
}
function parseEnv(env) {
  var appid = env.appid,
    appId = env.appId,
    container = env.container,
    os = env.os,
    version = env.version,
    sdkId = env.sdkId,
    sdkVersion = env.sdkVersion;
  return {
    s_aid: Number(appid) || Number(appId),
    s_sid: sdkId,
    s_container: container,
    s_os: os,
    s_version: version,
    s_sversion: sdkVersion
  };
}
function parseCondition(condition) {
  var appid = condition.appid,
    container = condition.container,
    os = condition.os,
    version = condition.version,
    hostId = condition.hostId;
  return {
    t_hid: appid || hostId,
    t_container: container,
    t_os: os,
    t_version: version
  };
}
function checkCondition(env, targetCondition, type) {
  if (Array.isArray(targetCondition)) {
    return targetCondition.some(function (item) {
      return checkCondition(env, item, type);
    });
  }
  var _parseEnv = parseEnv(env),
    s_aid = _parseEnv.s_aid,
    s_sid = _parseEnv.s_sid,
    s_os = _parseEnv.s_os,
    s_container = _parseEnv.s_container,
    s_version = _parseEnv.s_version,
    s_sversion = _parseEnv.s_sversion;
  var _parseCondition = parseCondition(targetCondition),
    t_hid = _parseCondition.t_hid,
    t_os = _parseCondition.t_os,
    t_container = _parseCondition.t_container,
    t_version = _parseCondition.t_version;
  if (type === 'sdk' && !s_sid) {
    // 如果是中台sdk，且没设置 sdkId，直接跳过
    return false;
  }
  if (type === 'sdk') {
    // 如果是中台sdk，判断 sid，否则判断 aid
    if (t_hid && t_hid !== '*' && t_hid !== s_sid) {
      return false;
    }
  } else {
    if (t_hid && t_hid !== '*' && t_hid !== s_aid) {
      return false;
    }
  }
  if (t_container !== '*' && t_container !== s_container) {
    return false;
  }
  if (t_os !== '*' && t_os !== s_os) {
    return false;
  }
  if (type === 'sdk') {
    // 如果是中台sdk，判断 sdkVersion，否则判断 version
    if (t_version && t_version !== '*' && !isVersionTargeted(s_sversion, t_version)) {
      return false;
    }
  } else {
    if (t_version && t_version !== '*' && !isVersionTargeted(s_version, t_version)) {
      return false;
    }
  }
  return true;
}
var isBrowser = typeof window !== 'undefined';
var ua = isBrowser ? window.navigator.userAgent : '';
var isAndroid = /(Android);?\s+([\d.]+)?/i.test(ua);

var BaseCore = /*#__PURE__*/function () {
  function BaseCore(config) {
    this.bridge = config.bridge;
    this.container = config.container || 'web';
    this.os = config.os;
    this.isSSR = config.isSSR;
    this.options = {};
    this.context = null;
    this.monitor = config.monitor;
    this.globalPostprocess = config.globalPostprocess;
    this.onInvokeStart = null;
    this.onInvokeEnd = null;
    this.logDisabled = false;
  }
  var _proto = BaseCore.prototype;
  _proto.on = function on(eventName, callback) {
    var _this = this;
    if (this.container === 'lynx') {
      this.bridge.on = this.bridge.on.bind(this.context); // 为lynx绑定this
    }
    var callbackId = this.bridge.on(eventName, function (data) {
      if (callback.length < 2) {
        callback(data);
      } else {
        // 兼容via的调用方式
        callback(null, data);
      }
    });
    return {
      remove: function remove() {
        return _this.bridge.off(eventName, callbackId);
      }
    };
  };
  _proto.globalConfig = function globalConfig(conf) {
    if (conf === void 0) {
      conf = {};
    }
    var _conf2 = conf,
      env = _conf2.env,
      context = _conf2.context,
      monitor = _conf2.monitor,
      onInvokeStart = _conf2.onInvokeStart,
      onInvokeEnd = _conf2.onInvokeEnd,
      disableLog = _conf2.disableLog,
      options = _conf2.options;
    this.logDisabled = disableLog ? true : false;
    // 因下面会通过this.env来判断是否初始设置了env，所以不能在constructor中设置
    var defaultEnv = {
      container: this.container,
      os: this.os
    };
    if (this.container === 'lynx' && context) {
      this.bridge.on = this.bridge.on.bind(context); // 为lynx绑定this
      this.bridge.off = this.bridge.off.bind(context); // 为lynx绑定this
    }

    // 注意！设置了env之后将不会再动态获取env
    if (env) {
      this.env = Object.assign({}, defaultEnv, env);
    }
    var _conf = {
      context: context,
      monitor: monitor,
      onInvokeStart: onInvokeStart,
      onInvokeEnd: onInvokeEnd,
      options: options
    };
    for (var key in _conf) {
      if (_conf[key] !== undefined) {
        this[key] = _conf[key];
      }
    }
  };
  return BaseCore;
}();
var CompatibleCore = /*#__PURE__*/function (_BaseCore) {
  function CompatibleCore(config) {
    var _this2;
    _this2 = _BaseCore.call(this, config) || this;
    _this2.env = config.env;
    return _this2;
  }
  _inheritsLoose(CompatibleCore, _BaseCore);
  var _proto2 = CompatibleCore.prototype;
  _proto2.init = function init(config) {
    var _this3 = this;
    var getRuntimeEnv = config.getRuntimeEnv;
    this.getEnv = new Promise(function (resolve, reject) {
      getRuntimeEnv({
        jsb: _this3.bridge,
        bridge: _this3.bridge,
        container: _this3.container,
        os: _this3.os
      }, function (err, res) {
        if (err) {
          reject(err);
        } else {
          if (!_this3.env) {
            _this3.env = Object.assign({
              container: _this3.container,
              os: _this3.os
            }, res);
          }
          resolve(_this3.env);
        }
      });
    })["finally"](function () {});
  };
  _proto2.getRuleForMethod = function getRuleForMethod(env, rules) {
    if (rules === void 0) {
      rules = [];
    }
    // 匹配方式，如果没有
    var matchRule = rules.sort(function (a, b) {
      return a.type === 'sdk' ? -1 : 1;
    }).find(function (rule) {
      return checkCondition(env, rule.target, rule.type);
    });
    return matchRule;
  };
  _proto2.transformConfig = function transformConfig(method, params, rules, env, type) {
    if (type === void 0) {
      type = 'call';
    }
    // 如果代码中设置了env则直接使用
    var rule = this.getRuleForMethod(env, rules) || {};
    var isHitRule = Boolean(rule.map || rule.interceptor);
    var realMethod = rule.map && rule.map.method || method;

    // 如果有 rule.map.module 则说明是 lynx 或者是 rn
    if (rule.map && rule.map.module && type !== 'on') {
      realMethod = rule.map;
    } else if (rule.map && rule.map.method) {
      realMethod = rule.map.method;
    }
    var realParams = rule.preprocess ? rule.preprocess(params, {
      env: env,
      bridge: this.bridge,
      logger: logger
    }) : params;
    if (process.env.NODE_ENV !== 'production' && false === this.logDisabled) {
      var logTitle = "[Queqiao Call Log: " + method + "]";
      var logContent = {
        hitRule: isHitRule ? rule : 'Rule not found, please check value of "appId, appVersion" in the parameter "env" or hook "getRuntimeEnv" on Queqiao platform.',
        rules: rules,
        env: env,
        sdkInfo: {
          method: method,
          params: params
        },
        jsbInfo: rule.map ? {
          method: realMethod,
          params: realParams
        } : null,
        type: type
      };
      if (isHitRule) {
        console.log(logTitle, logContent);
      } else {
         console.warn(logTitle, logContent);
      }
    }
    return {
      realMethod: realMethod,
      realParams: realParams,
      rule: rule,
      env: env
    };
  };
  _proto2.caniuse = function caniuse(func, env) {
    var rules = func(null, null, null, {
      getRules: true
    });
    var rule = this.getRuleForMethod(Object.assign({
      container: this.container,
      os: this.os
    }, env), rules);
    return !!rule;
  };
  _proto2.callExecutor = function callExecutor(resolve, reject, _env, method, params, callback, rules, options, usePromise) {
    var _this4 = this;
    var hookConfig = {
      method: method,
      params: params
    };
    if (this.onInvokeStart) {
      hookConfig = this.onInvokeStart(hookConfig);
    }
    var _this$transformConfig = this.transformConfig(method, params, rules, _env),
      realMethod = _this$transformConfig.realMethod,
      realParams = _this$transformConfig.realParams,
      rule = _this$transformConfig.rule,
      env = _this$transformConfig.env;

    // 增加拦截器配置
    var interceptor = rule.interceptor;

    // 监控开始时间
    var startTimestamp = new Date().getTime();

    // 如果有拦截器，忽略所有预处理配置
    if (typeof interceptor === 'function') {
      return interceptor(Object.assign({
        params: params,
        bridge: this.bridge
      }, env), function (data) {
        resolve(data);
        if (typeof callback === 'function') {
          callback(data);
        }
        if (typeof _this4.onInvokeEnd === 'function') {
          _this4.onInvokeEnd({
            response: data,
            config: hookConfig
          });
        }
      });
    }
    this.bridge.call(realMethod, realParams, function (realRes) {
      var res = realRes;
      try {
        if (typeof _this4.globalPostprocess === 'function') {
          res = _this4.globalPostprocess(res, {
            method: method,
            params: params,
            env: env
          });
        }
        if (typeof rule.postprocess === 'function') {
          res = rule.postprocess(res, {
            method: method,
            params: params,
            env: env
          });
        }
      } catch (error) {
        reject(error);
      }
      if (typeof callback === 'function') {
        if (callback.length < 2) {
          callback(res);
        } else {
          // 兼容via的调用方式
          callback(null, res);
        }
      }
      resolve(res);
      if (typeof _this4.onInvokeEnd === 'function') {
        _this4.onInvokeEnd({
          response: res,
          config: hookConfig
        });
      }
      if (typeof _this4.monitor === 'function') {
        _this4.monitor(Object.assign({
          bridge: _this4.bridge
        }, env), {
          method: method,
          realMethod: realMethod,
          params: params,
          realParams: realParams,
          res: res,
          realRes: realRes,
          rules: rules,
          rule: rule,
          startTimestamp: startTimestamp
        });
      }
    }, Object.assign(this.options, options));
  };
  _proto2.pipeCall = function pipeCall(_ref, usePromise) {
    var _this5 = this;
    var method = _ref.method,
      params = _ref.params,
      callback = _ref.callback,
      rules = _ref.rules,
      options = _ref.options,
      internal = _ref.internal;
    if (usePromise === void 0) {
      usePromise = true;
    }
    if (this.isSSR) {
      return Promise.resolve();
    }
    return new Promise(function (resolve, reject) {
      try {
        if (!_this5.env) {
          _this5.getEnv.then(function (env) {
            _this5.callExecutor(resolve, reject, env, method, params, callback, rules, options, usePromise);
          });
        } else {
          _this5.callExecutor(resolve, reject, _this5.env, method, params, callback, rules, options, usePromise);
        }
      } catch (error) {
        if (typeof _this5.monitor === 'function') {
          _this5.monitor({
            bridge: _this5.bridge,
            env: _this5.env
          }, {
            method: method,
            params: params,
            rules: rules,
            error: error
          });
        }
        reject(error);
      }
    });
  };
  _proto2.pipeEvent = function pipeEvent(_ref2) {
    var _this6 = this;
    var event = _ref2.event,
      callback = _ref2.callback,
      rules = _ref2.rules,
      once = _ref2.once,
      internal = _ref2.internal;
    if (this.isSSR) {
      return {
        remove: function remove() {},
        listener: callback
      };
    }
    var promise = new Promise(function (resolve, reject) {
      var _env = _this6.env;
      if (!_env) {
        _this6.getEnv.then(function (res) {
          resolve(_this6.transformConfig(event, null, rules, res, 'on'));
        });
      } else {
        resolve(_this6.transformConfig(event, null, rules, _env, 'on'));
      }
    });
    var executor = promise.then(function (_ref3) {
      var realMethod = _ref3.realMethod,
        rule = _ref3.rule,
        env = _ref3.env;
      // 增加拦截器配置
      var interceptor = rule.interceptor;

      // 如果有拦截器，忽略所有预处理配置
      if (typeof interceptor === 'function') {
        return interceptor(Object.assign({
          bridge: _this6.bridge
        }, env), function (data) {
          if (typeof callback === 'function') {
            callback(data);
          }
        });
      }
      var realCallback = function realCallback(realRes) {
        var res = realRes;
        if (typeof _this6.globalPostprocess === 'function') {
          res = _this6.globalPostprocess(res, {
            event: event,
            env: env,
            logger: logger
          });
        }
        if (typeof rule.postprocess === 'function') {
          res = rule.postprocess(res, {
            event: event,
            env: env,
            logger: logger
          });
        }
        if (rule.postprocess) {
          if (res !== null) {
            // 约定如果返回除null以外的任何数据才调用callback
            callback(res);
          }
        } else {
          callback(res);
        }
      };
      var callbackId = _this6.bridge.on(realMethod, realCallback, once);
      return [realMethod, callbackId];
    });
    return {
      remove: function remove() {
        executor.then(function (_ref4) {
          var realMethod = _ref4[0],
            callbackId = _ref4[1];
          _this6.bridge.off(realMethod, callbackId);
        });
      },
      listener: callback
    };
  };
  return CompatibleCore;
}(BaseCore);
var UniversalCore = /*#__PURE__*/function (_BaseCore2) {
  function UniversalCore(config) {
    var _this7;
    _this7 = _BaseCore2.call(this, config) || this;
    _this7.env = {
      container: config.container || 'web',
      os: config.os
    };
    return _this7;
  }
  _inheritsLoose(UniversalCore, _BaseCore2);
  var _proto3 = UniversalCore.prototype;
  _proto3.caniuse = function caniuse(func, env) {
    console.error(func + " is not a rule-dependent method, you should not call caniuse in your code");
    return false;
  };
  _proto3.pipeCall = function pipeCall(method, realMethod, params, callback, options, interceptor) {
    var _this8 = this;
    if (this.isSSR) {
      return Promise.resolve();
    }
    var hookConfig = {
      method: method,
      params: params
    };
    if (typeof this.onInvokeStart === 'function') {
      hookConfig = this.onInvokeStart(hookConfig);
    }

    // 监控开始时间
    var startTimestamp = new Date().getTime();
    if (process.env.NODE_ENV !== 'production' && false === this.logDisabled) {
      console.log("[Queqiao Call Log: " + method + "]", {
        env: this.env,
        sdkInfo: {
          method: method,
          params: params
        },
        jsbInfo: {
          method: Boolean(interceptor) ? '[interceptor]' : realMethod,
          params: params
        },
        type: 'call'
      });
    }
    try {
      return new Promise(function (resolve, reject) {
        if (typeof interceptor === 'function') {
          return interceptor(Object.assign({
            params: params,
            bridge: _this8.bridge
          }, _this8.env), function (data) {
            resolve(data);
            if (typeof callback === 'function') {
              callback(data);
            }
            if (typeof _this8.onInvokeEnd === 'function') {
              _this8.onInvokeEnd({
                response: data,
                config: hookConfig
              });
            }
          });
        }
        _this8.bridge.call(realMethod, params, function (realRes) {
          var res = realRes;
          try {
            if (typeof _this8.globalPostprocess === 'function') {
              res = _this8.globalPostprocess(res, {
                method: method,
                params: params,
                env: _this8.env
              });
            }
          } catch (error) {
            reject(error);
          }
          if (typeof callback === 'function') {
            if (callback.length < 2) {
              callback(res);
            } else {
              // 兼容via的调用方式
              callback(null, res);
            }
          }
          resolve(res);
          if (typeof _this8.onInvokeEnd === 'function') {
            _this8.onInvokeEnd({
              response: res,
              config: hookConfig
            });
          }
          if (typeof _this8.monitor === 'function') {
            _this8.monitor(Object.assign({
              bridge: _this8.bridge
            }, _this8.env), {
              method: method,
              realMethod: realMethod,
              params: params,
              res: res,
              realRes: realRes,
              startTimestamp: startTimestamp
            });
          }
        }, Object.assign(_this8.options, options));
      });
    } catch (error) {
      if (typeof this.monitor === 'function') {
        this.monitor(Object.assign({
          bridge: this.bridge
        }, this.env), {
          method: method,
          realMethod: realMethod,
          params: params,
          error: error
        });
      }
      return Promise.reject(error);
    }
  };
  _proto3.pipeEvent = function pipeEvent(event, realEvent, callback, once) {
    var _this9 = this;
    if (this.isSSR) {
      return {
        remove: function remove() {},
        listener: callback
      };
    }
    if (process.env.NODE_ENV !== 'production' && false === this.logDisabled) {
      console.log("[Queqiao Call Log: " + event + "]", {
        env: this.env,
        sdkInfo: {
          method: event,
          params: null
        },
        jsbInfo: {
          method: realEvent,
          params: null
        },
        type: 'on'
      });
    }
    var realCallback = function realCallback(realRes) {
      var res = realRes;
      if (typeof _this9.globalPostprocess === 'function') {
        res = _this9.globalPostprocess(res, {
          event: event,
          env: _this9.env,
          logger: logger
        });
      }
      callback(res);
    };
    var callbackId = this.bridge.on(realEvent, realCallback, once);
    return {
      remove: function remove() {
        _this9.bridge.off(realEvent, callbackId);
      },
      listener: callback
    };
  };
  return UniversalCore;
}(BaseCore);

var core = new CompatibleCore({
  bridge: isBrowser ? window.JSBridge : {},
  container: 'web',
  os: isAndroid ? 'android' : 'ios',
  isSSR: !isBrowser,
  monitor: monitor,
  globalPostprocess: responseProcess
});
core.init({
  getRuntimeEnv: isBrowser ? getRuntimeEnv : function (_, callback) {
    callback(null, {});
  }
});

var rules = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "app.geckoUpdate"
  }
}];

function geckoUpdate(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "geckoUpdate",
            params: params,
            callback: callback,
            rules: rules,
            options: options,
            internal: internal,
        });
    }
}

var rules$1 = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "app.trackEvents"
  }
}];

function trackEvents(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$1; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "trackEvents",
            params: params,
            callback: callback,
            rules: rules$1,
            options: options,
            internal: internal,
        });
    }
}

var rules$2 = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "app.shareImage"
  }
}];

function shareImage(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$2; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "shareImage",
            params: params,
            callback: callback,
            rules: rules$2,
            options: options,
            internal: internal,
        });
    }
}

var rules$3 = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "app.showLoading"
  }
}];

function showLoading(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$3; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "showLoading",
            params: params,
            callback: callback,
            rules: rules$3,
            options: options,
            internal: internal,
        });
    }
}

var rules$4 = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "app.finishLoading"
  }
}];

function finishLoading(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$4; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "finishLoading",
            params: params,
            callback: callback,
            rules: rules$4,
            options: options,
            internal: internal,
        });
    }
}

var rules$5 = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "app.getAppInfo"
  },
  /**
   * 回参预处理函数
   * @param {object} params  客户端回参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   * @param {object} ctx.params  入参
   */
  postprocess: function responseProcess(params, ctx) {
    if (params.code === 1) {
      return params.data || {};
    }
    return params.data || {};
  }
}];

function getAppInfo(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$5; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "getAppInfo",
            params: params,
            callback: callback,
            rules: rules$5,
            options: options,
            internal: internal,
        });
    }
}

var rules$6 = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "app.getUserInfo"
  },
  /**
   * 回参预处理函数
   * @param {object} params  客户端回参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   * @param {object} ctx.params  入参
   */
  postprocess: function responseProcess(params, ctx) {
    if (params.code === 1) {
      return params.data;
    }
    return params.data || {};
  }
}];

function getUserInfo(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$6; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "getUserInfo",
            params: params,
            callback: callback,
            rules: rules$6,
            options: options,
            internal: internal,
        });
    }
}

var rules$7 = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "app.login"
  },
  /**
   * 回参预处理函数
   * @param {object} params  客户端回参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   * @param {object} ctx.params  入参
   */
  postprocess: function responseProcess(params, ctx) {
    if (params.code === 1) {
      return params.data || {};
    }
    return params.data || {};
  }
}];

function login(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$7; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "login",
            params: params,
            callback: callback,
            rules: rules$7,
            options: options,
            internal: internal,
        });
    }
}

var rules$8 = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "app.share"
  },
  /**
   * 入参预处理函数
   * @param {object} params  兼容方法入参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   */
  preprocess: function requestProcess(params, ctx) {
    return Object.assign({}, params, {
      event_params: params.eventParams // 兼容iOS < 1.8.2
    });
  }
}];

function share(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$8; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "share",
            params: params,
            callback: callback,
            rules: rules$8,
            options: options,
            internal: internal,
        });
    }
}

var rules$9 = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "app.valueForKey"
  }
}];

var JSBridgeCode;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode || (JSBridgeCode = {}));
function valueForKey(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$9; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "valueForKey",
            params: params,
            callback: callback,
            rules: rules$9,
            options: options,
            internal: internal,
        });
    }
}

var rules$a = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "app.setValueForKey"
  }
}];

var JSBridgeCode$1;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$1 || (JSBridgeCode$1 = {}));
function setValueForKey(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$a; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "setValueForKey",
            params: params,
            callback: callback,
            rules: rules$a,
            options: options,
            internal: internal,
        });
    }
}

var rules$b = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "2.1.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "app.uploadImage"
  },
  /**
   * 回参预处理函数
   * @param {object} params  客户端回参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   * @param {object} ctx.params  入参
   */
  postprocess: function responseProcess(params, ctx) {
    return params.data || {};
  }
}];

function uploadImage(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$b; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "uploadImage",
            params: params,
            callback: callback,
            rules: rules$b,
            options: options,
            internal: internal,
        });
    }
}

var rules$c = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "app.openAlbum"
  },
  /**
   * 回参预处理函数
   * @param {object} params  客户端回参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   * @param {object} ctx.params  入参
   */
  postprocess: function responseProcess(params, ctx) {
    if (params.code === 1) {
      return {
        image: params.data.image
      };
    }
    return {
      image: ""
    };
  }
}];

function openAlbum(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$c; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "openAlbum",
            params: params,
            callback: callback,
            rules: rules$c,
            options: options,
            internal: internal,
        });
    }
}

var rules$d = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "app.enterPublishPage"
  }
}];

function enterPublishPage(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$d; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "enterPublishPage",
            params: params,
            callback: callback,
            rules: rules$d,
            options: options,
            internal: internal,
        });
    }
}

var rules$e = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "app.onShareOperate"
  }
}];

/**
 * @supportContainer web
 */
function onShareOperate(callback, once, options, internal) {
    if (internal && internal.getRules) {
        return rules$e; // 提供给caniuse使用
    }
    else {
        return core.pipeEvent({
            event: "onShareOperate",
            callback: callback,
            rules: rules$e,
            once: once,
            internal: internal,
        });
    }
}

var rules$f = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "app.saveImage"
  },
  /**
   * 回参预处理函数
   * @param {object} params  客户端回参
   * @param {'ios'|'android'|'pc'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   * @param {object} ctx.params  入参
   */
  postprocess: function responseProcess(params, ctx) {
    var _params$data3;
    if (params.code === 1) {
      var _params$data;
      if (typeof ((_params$data = params.data) == null ? void 0 : _params$data.fail_reason) !== "undefined") {
        var _params$data2;
        return {
          result: "fail",
          fail_reason: (_params$data2 = params.data) == null ? void 0 : _params$data2.fail_reason
        };
      }
      return {
        result: "success"
      };
    }
    return {
      result: "fail",
      fail_reason: (_params$data3 = params.data) == null ? void 0 : _params$data3.fail_reason
    };
  }
}];

function saveImage(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$f; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "saveImage",
            params: params,
            callback: callback,
            rules: rules$f,
            options: options,
            internal: internal,
        });
    }
}

var nativeJoin = [].join;

var ES3_STRINGS = indexedObject != Object;
var STRICT_METHOD$4 = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
_export({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$4 }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

var $includes = arrayIncludes.includes;


// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var rules$g = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "app.fetch"
  },
  /**
   * 入参预处理函数
   * @param {object} params  兼容方法入参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   */
  preprocess: function requestProcess(params, ctx) {
    var originUrl = params.url,
      _params$method = params.method,
      method = _params$method === void 0 ? "get" : _params$method,
      _params$data = params.data,
      data = _params$data === void 0 ? {} : _params$data,
      insideParams = params.params,
      _params$needCommonPar = params.needCommonParams,
      needCommonParams = _params$needCommonPar === void 0 ? true : _params$needCommonPar,
      _params$headers = params.headers,
      headers = _params$headers === void 0 ? "" : _params$headers;
    var methodLowerCase = method.toLowerCase();
    var url = originUrl;
    // 将get请求参数全部拼到query中，需要注意一定要encode，否则带日语会出现问题
    if (methodLowerCase === "get") {
      var query = Object.keys(data).map(function (key) {
        return key + "=" + encodeURIComponent(data[key]);
      }).join("&");
      url = Object.keys(data).length > 0 ? originUrl + "?" + query : originUrl;
    }
    if (methodLowerCase === "post") {
      // 兼容魔方发送post请求时使用的是params字段，端上消费的为data字段
      if (!params.data) {
        params.data = {};
      }
      Object.assign(params.data, insideParams || {});
      // 兼容魔方
      if (url.includes("/magic")) {
        params.useForm = false;
        params.isInnerDomain = false;
        params.needCommonParams = false;
      }
    }
    var headerParams = {};
    if (headers) {
      if (typeof headers === "string") {
        try {
          headerParams = JSON.parse(headers);
        } catch (error) {
          console.error("headers parse error ===:", JSON.stringify(error));
        }
      } else if (typeof headers === "object") {
        headerParams = headers;
      }
    }
    headerParams.view_type = typeof window !== "undefined" ? "webview" : "lynx";
    return Object.assign({
      needCommonParams: needCommonParams
    }, params, {
      headers: JSON.stringify(headerParams),
      url: url,
      method: methodLowerCase
    });
  },
  /**
   * 回参预处理函数
   * @param {object} params  客户端回参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   * @param {object} ctx.params  入参
   */
  postprocess: function responseProcess(params, ctx) {
    if (params.code === 1) {
      return params.data;
    }
    return {
      data: {},
      message: "fail",
      code: params.code
    };
  }
}];

function fetch(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$g; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "fetch",
            params: params,
            callback: callback,
            rules: rules$g,
            options: options,
            internal: internal,
        });
    }
}

var core$1 = new UniversalCore({
  bridge: isBrowser ? window.JSBridge : {},
  container: 'web',
  os: isAndroid ? 'android' : 'ios',
  isSSR: !isBrowser,
  monitor: monitor,
  globalPostprocess: responseProcess
});

var JSBridgeCode$2;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$2 || (JSBridgeCode$2 = {}));
/**
 * @supportContainer web | lynx
 */
function uploadImageByPath(params, callback, options) {
    return core$1.pipeCall("uploadImageByPath", "app.uploadImageByPath", params, callback, options);
}

var JSBridgeCode$3;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$3 || (JSBridgeCode$3 = {}));
/**
 * @supportContainer web | lynx
 */
function chooseImages(params, callback, options) {
    return core$1.pipeCall("chooseImages", "app.chooseImages", params, callback, options);
}

var JSBridgeCode$4;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$4 || (JSBridgeCode$4 = {}));
/**
 * @supportContainer lynx | web
 */
function copyToClipboard(params, callback, options) {
    return core$1.pipeCall("copyToClipboard", "app.copyToClipboard", params, callback, options);
}

var JSBridgeCode$5;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$5 || (JSBridgeCode$5 = {}));
/**
 * @supportContainer web | lynx
 */
function vibration(params, callback, options) {
    return core$1.pipeCall("vibration", "app.vibration", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function prefetchImage(params, callback, options) {
    return core$1.pipeCall("prefetchImage", "app.prefetchImage", params, callback, options);
}

/**
 * @supportContainer web
 */
function share2platform(params, callback, options) {
    return core$1.pipeCall("share2platform", "app.share2platform", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function saveArticles(params, callback, options) {
    return core$1.pipeCall("saveArticles", "app.saveArticles", params, callback, options);
}

/**
 * @supportContainer web
 */
function getMediaInfo(params, callback, options) {
    return core$1.pipeCall("getMediaInfo", "app.getMediaInfo", params, callback, options);
}

/**
 * @supportContainer lynx
 */
function logFeedbackInfo(params, callback, options) {
    return core$1.pipeCall("logFeedbackInfo", "app.logFeedbackInfo", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function openSystemPushPage(params, callback, options) {
    return core$1.pipeCall("openSystemPushPage", "app.openSystemPushPage", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function getPushStatus(params, callback, options) {
    return core$1.pipeCall("getPushStatus", "app.getPushStatus", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function getApiCommonParams(params, callback, options) {
    return core$1.pipeCall("getApiCommonParams", "app.getApiCommonParams", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function screenTimeUpdate(params, callback, options) {
    return core$1.pipeCall("screenTimeUpdate", "app.screenTimeUpdate", params, callback, options);
}



var app = /*#__PURE__*/Object.freeze({
	__proto__: null,
	geckoUpdate: geckoUpdate,
	trackEvents: trackEvents,
	shareImage: shareImage,
	showLoading: showLoading,
	finishLoading: finishLoading,
	getAppInfo: getAppInfo,
	getUserInfo: getUserInfo,
	login: login,
	share: share,
	valueForKey: valueForKey,
	setValueForKey: setValueForKey,
	uploadImage: uploadImage,
	openAlbum: openAlbum,
	enterPublishPage: enterPublishPage,
	onShareOperate: onShareOperate,
	saveImage: saveImage,
	fetch: fetch,
	uploadImageByPath: uploadImageByPath,
	chooseImages: chooseImages,
	copyToClipboard: copyToClipboard,
	vibration: vibration,
	prefetchImage: prefetchImage,
	share2platform: share2platform,
	saveArticles: saveArticles,
	getMediaInfo: getMediaInfo,
	logFeedbackInfo: logFeedbackInfo,
	openSystemPushPage: openSystemPushPage,
	getPushStatus: getPushStatus,
	getApiCommonParams: getApiCommonParams,
	screenTimeUpdate: screenTimeUpdate
});

var rules$h = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "view.open"
  }
}];

function open(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$h; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "open",
            params: params,
            callback: callback,
            rules: rules$h,
            options: options,
            internal: internal,
        });
    }
}

var rules$i = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "view.goProfile"
  }
}];

function goProfile(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$i; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "goProfile",
            params: params,
            callback: callback,
            rules: rules$i,
            options: options,
            internal: internal,
        });
    }
}

var rules$j = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "view.preventBack"
  },
  /**
   * 入参预处理函数
   * @param {object} params  兼容方法入参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   */
  preprocess: function requestProcess(params, ctx) {
    return {
      is_prevent: Number(params.isPrevent)
    };
  }
}];

function preventBack(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$j; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "preventBack",
            params: params,
            callback: callback,
            rules: rules$j,
            options: options,
            internal: internal,
        });
    }
}

var rules$k = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "view.preventScroll"
  },
  /**
   * 入参预处理函数
   * @param {object} params  兼容方法入参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   */
  preprocess: function requestProcess(params, ctx) {
    return {
      is_prevent: Number(params.isPrevent)
    };
  }
}];

function preventScroll(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$k; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "preventScroll",
            params: params,
            callback: callback,
            rules: rules$k,
            options: options,
            internal: internal,
        });
    }
}

var rules$l = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "view.getKeyboardHeight"
  },
  /**
   * 回参预处理函数
   * @param {object} params  客户端回参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   * @param {object} ctx.params  入参
   */
  postprocess: function responseProcess(params, ctx) {
    if (params.code === 1) {
      return params.data;
    }
    return params.data || {};
  }
}];

function getKeyboardHeight(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$l; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "getKeyboardHeight",
            params: params,
            callback: callback,
            rules: rules$l,
            options: options,
            internal: internal,
        });
    }
}

var rules$m = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "view.setKeyboardVisible"
  },
  /**
   * 入参预处理函数
   * @param {object} params  兼容方法入参
   * @param {'ios'|'android'} ctx.env.os  运行系统
   * @param {string} ctx.env.version  运行宿主版本
   */
  preprocess: function requestProcess(params, ctx) {
    return {
      is_visible: Number(params.isVisible)
    };
  }
}];

function setKeyboardVisible(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$m; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "setKeyboardVisible",
            params: params,
            callback: callback,
            rules: rules$m,
            options: options,
            internal: internal,
        });
    }
}

var rules$n = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "view.closeActivity"
  }
}];

function closeActivity(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$n; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "closeActivity",
            params: params,
            callback: callback,
            rules: rules$n,
            options: options,
            internal: internal,
        });
    }
}

var rules$o = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "view.domReady"
  }
}];

function domReady(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$o; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "domReady",
            params: params,
            callback: callback,
            rules: rules$o,
            options: options,
            internal: internal,
        });
    }
}

var rules$p = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "view.backWillTrigger"
  }
}];

/**
 * @supportContainer web | lynx
 */
function onBackWillTrigger(callback, once, options, internal) {
    if (internal && internal.getRules) {
        return rules$p; // 提供给caniuse使用
    }
    else {
        return core.pipeEvent({
            event: "onBackWillTrigger",
            callback: callback,
            rules: rules$p,
            once: once,
            internal: internal,
        });
    }
}

var rules$q = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "view.pageActivate"
  }
}];

/**
 * @supportContainer web
 */
function onPageActivate(callback, once, options, internal) {
    if (internal && internal.getRules) {
        return rules$q; // 提供给caniuse使用
    }
    else {
        return core.pipeEvent({
            event: "onPageActivate",
            callback: callback,
            rules: rules$q,
            once: once,
            internal: internal,
        });
    }
}

var rules$r = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "view.onKeyboardWillShow"
  }
}];

/**
 * @supportContainer web | lynx
 */
function onKeyboardWillShow(callback, once, options, internal) {
    if (internal && internal.getRules) {
        return rules$r; // 提供给caniuse使用
    }
    else {
        return core.pipeEvent({
            event: "onKeyboardWillShow",
            callback: callback,
            rules: rules$r,
            once: once,
            internal: internal,
        });
    }
}

var rules$s = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "view.onKeyboardDidShow"
  }
}];

/**
 * @supportContainer web
 */
function onKeyboardDidShow(callback, once, options, internal) {
    if (internal && internal.getRules) {
        return rules$s; // 提供给caniuse使用
    }
    else {
        return core.pipeEvent({
            event: "onKeyboardDidShow",
            callback: callback,
            rules: rules$s,
            once: once,
            internal: internal,
        });
    }
}

var rules$t = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }],
  map: {
    method: "view.onKeyboardWillHide"
  }
}];

/**
 * @supportContainer web | lynx
 */
function onKeyboardWillHide(callback, once, options, internal) {
    if (internal && internal.getRules) {
        return rules$t; // 提供给caniuse使用
    }
    else {
        return core.pipeEvent({
            event: "onKeyboardWillHide",
            callback: callback,
            rules: rules$t,
            once: once,
            internal: internal,
        });
    }
}

var rules$u = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "view.onKeyboardDidHide"
  }
}];

/**
 * @supportContainer web
 */
function onKeyboardDidHide(callback, once, options, internal) {
    if (internal && internal.getRules) {
        return rules$u; // 提供给caniuse使用
    }
    else {
        return core.pipeEvent({
            event: "onKeyboardDidHide",
            callback: callback,
            rules: rules$u,
            once: once,
            internal: internal,
        });
    }
}

var JSBridgeCode$6;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$6 || (JSBridgeCode$6 = {}));
/**
 * @supportContainer web | lynx
 */
function openBrowser(params, callback, options) {
    return core$1.pipeCall("openBrowser", "view.openBrowser", params, callback, options);
}

var JSBridgeCode$7;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$7 || (JSBridgeCode$7 = {}));
/**
 * @supportContainer web | lynx
 */
function bottomToast(params, callback, options) {
    return core$1.pipeCall("bottomToast", "view.bottomToast", params, callback, options);
}

var JSBridgeCode$8;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$8 || (JSBridgeCode$8 = {}));
/**
 * @supportContainer web | lynx
 */
function toast(params, callback, options) {
    return core$1.pipeCall("toast", "view.toast", params, callback, options);
}

var JSBridgeCode$9;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$9 || (JSBridgeCode$9 = {}));
/**
 * @supportContainer web | lynx
 */
function dialog(params, callback, options) {
    return core$1.pipeCall("dialog", "view.dialog", params, callback, options);
}

/**
 * @supportContainer web
 */
function setTitleVisible(params, callback, options) {
    return core$1.pipeCall("setTitleVisible", "view.setTitleVisible", params, callback, options);
}

var JSBridgeCode$a;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$a || (JSBridgeCode$a = {}));
/**
 * @supportContainer web | lynx
 */
function onVisibleChange(callback, once) {
    return core$1.pipeEvent("onVisibleChange", "view.onVisibleChange", callback, once);
}

/**
 * @supportContainer web | lynx
 */
function snackbar(params, callback, options) {
    return core$1.pipeCall("snackbar", "view.snackbar", params, callback, options);
}

/**
 * @supportContainer web
 */
function onCloseSetUpProfile(callback, once) {
    return core$1.pipeEvent("onCloseSetUpProfile", "view.onCloseSetUpProfile", callback, once);
}

/**
 * @supportContainer web | lynx
 */
function precreateKitView(params, callback, options) {
    return core$1.pipeCall("precreateKitView", "view.precreateKitView", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function removeWebViewLoading(params, callback, options) {
    return core$1.pipeCall("removeWebViewLoading", "view.removeWebViewLoading", params, callback, options);
}

/**
 * @supportContainer web
 */
function disableIOSWebViewFocusAutoScroll(params, callback, options) {
    return core$1.pipeCall("disableIOSWebViewFocusAutoScroll", "view.disableIOSWebViewFocusAutoScroll", params, callback, options);
}



var view = /*#__PURE__*/Object.freeze({
	__proto__: null,
	open: open,
	goProfile: goProfile,
	preventBack: preventBack,
	preventScroll: preventScroll,
	getKeyboardHeight: getKeyboardHeight,
	setKeyboardVisible: setKeyboardVisible,
	closeActivity: closeActivity,
	domReady: domReady,
	onBackWillTrigger: onBackWillTrigger,
	onPageActivate: onPageActivate,
	onKeyboardWillShow: onKeyboardWillShow,
	onKeyboardDidShow: onKeyboardDidShow,
	onKeyboardWillHide: onKeyboardWillHide,
	onKeyboardDidHide: onKeyboardDidHide,
	openBrowser: openBrowser,
	bottomToast: bottomToast,
	toast: toast,
	dialog: dialog,
	setTitleVisible: setTitleVisible,
	onVisibleChange: onVisibleChange,
	snackbar: snackbar,
	onCloseSetUpProfile: onCloseSetUpProfile,
	precreateKitView: precreateKitView,
	removeWebViewLoading: removeWebViewLoading,
	disableIOSWebViewFocusAutoScroll: disableIOSWebViewFocusAutoScroll
});

var rules$v = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "user.getUserSubscribe"
  }
}];

function getUserSubscribe(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$v; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "getUserSubscribe",
            params: params,
            callback: callback,
            rules: rules$v,
            options: options,
            internal: internal,
        });
    }
}

var rules$w = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "user.setSkinData"
  }
}];

function setSkinData(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$w; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "setSkinData",
            params: params,
            callback: callback,
            rules: rules$w,
            options: options,
            internal: internal,
        });
    }
}

/**
 * @supportContainer web | lynx
 */
function onSubscriptionChanged(callback, once) {
    return core$1.pipeEvent("onSubscriptionChanged", "user.onSubscriptionChanged", callback, once);
}

/**
 * @supportContainer web | lynx
 */
function subscribe(params, callback, options) {
    return core$1.pipeCall("subscribe", "user.subscribe", params, callback, options);
}



var user = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getUserSubscribe: getUserSubscribe,
	setSkinData: setSkinData,
	onSubscriptionChanged: onSubscriptionChanged,
	subscribe: subscribe
});

var rules$x = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }, {
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }],
  map: {
    method: "action.followUser"
  }
}];

function followUser(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$x; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "followUser",
            params: params,
            callback: callback,
            rules: rules$x,
            options: options,
            internal: internal,
        });
    }
}

var rules$y = [];

function onFollowUserChange(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$y; // 提供给caniuse使用
    }
    else {
        return Promise.reject("This method can only be called in the lynx");
    }
}

var rules$z = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "action.articleDigg"
  }
}];

function articleDigg(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$z; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "articleDigg",
            params: params,
            callback: callback,
            rules: rules$z,
            options: options,
            internal: internal,
        });
    }
}

/**
 * @supportContainer web | lynx
 */
function onLikeArticleChange(callback, once) {
    return core$1.pipeEvent("onLikeArticleChange", "action.onLikeArticleChange", callback, once);
}

/**
 * @supportContainer web | lynx
 */
function onFavoriteChange(callback, once) {
    return core$1.pipeEvent("onFavoriteChange", "action.onFavoriteChange", callback, once);
}

/**
 * @supportContainer web | lynx
 */
function favorite(params, callback, options) {
    return core$1.pipeCall("favorite", "action.favorite", params, callback, options);
}



var action = /*#__PURE__*/Object.freeze({
	__proto__: null,
	followUser: followUser,
	onFollowUserChange: onFollowUserChange,
	articleDigg: articleDigg,
	onLikeArticleChange: onLikeArticleChange,
	onFavoriteChange: onFavoriteChange,
	favorite: favorite
});

var rules$A = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "search.inView"
  }
}];

function inView(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$A; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "inView",
            params: params,
            callback: callback,
            rules: rules$A,
            options: options,
            internal: internal,
        });
    }
}

var rules$B = [{
  target: [{
    hostId: 2657,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 2657,
    os: "*",
    version: "2.4.0-",
    container: "lynx"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "web"
  }, {
    hostId: 580589,
    os: "*",
    version: "0.0.0-",
    container: "lynx"
  }],
  map: {
    method: "search.outOfView"
  }
}];

function outOfView(params, callback, options, internal) {
    if (internal && internal.getRules) {
        return rules$B; // 提供给caniuse使用
    }
    else {
        return core.pipeCall({
            method: "outOfView",
            params: params,
            callback: callback,
            rules: rules$B,
            options: options,
            internal: internal,
        });
    }
}

/**
 * @supportContainer web | lynx
 */
function getResultList(params, callback, options) {
    return core$1.pipeCall("getResultList", "search.getResultList", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function saveResultList(params, callback, options) {
    return core$1.pipeCall("saveResultList", "search.saveResultList", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function clearSearchResult(params, callback, options) {
    return core$1.pipeCall("clearSearchResult", "search.clearSearchResult", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function onScrollToArticle(callback, once) {
    return core$1.pipeEvent("onScrollToArticle", "search.onScrollToArticle", callback, once);
}

/**
 * @supportContainer web | lynx
 */
function onSearchLoadmore(callback, once) {
    return core$1.pipeEvent("onSearchLoadmore", "search.onSearchLoadmore", callback, once);
}



var search = /*#__PURE__*/Object.freeze({
	__proto__: null,
	inView: inView,
	outOfView: outOfView,
	getResultList: getResultList,
	saveResultList: saveResultList,
	clearSearchResult: clearSearchResult,
	onScrollToArticle: onScrollToArticle,
	onSearchLoadmore: onSearchLoadmore
});

var JSBridgeCode$b;
(function (JSBridgeCode) {
    JSBridgeCode[JSBridgeCode["Success"] = 1] = "Success";
    JSBridgeCode[JSBridgeCode["Failed"] = 0] = "Failed";
})(JSBridgeCode$b || (JSBridgeCode$b = {}));
/**
 * @supportContainer web | lynx
 */
function imagesViewer(params, callback, options) {
    return core$1.pipeCall("imagesViewer", "media.imagesViewer", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function onImageUploaded(callback, once) {
    return core$1.pipeEvent("onImageUploaded", "media.onImageUploaded", callback, once);
}

/**
 * @supportContainer web
 */
function cameraAuthorized(params, callback, options) {
    return core$1.pipeCall("cameraAuthorized", "media.cameraAuthorized", params, callback, options);
}

/**
 * @supportContainer web
 */
function openToolCamera(params, callback, options) {
    return core$1.pipeCall("openToolCamera", "media.openToolCamera", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function albumAuthorized(params, callback, options) {
    return core$1.pipeCall("albumAuthorized", "media.albumAuthorized", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function openImageView(params, callback, options) {
    return core$1.pipeCall("openImageView", "media.openImageView", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function openSettings(params, callback, options) {
    return core$1.pipeCall("openSettings", "media.openSettings", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function onAuthorizeLocationChange(callback, once) {
    return core$1.pipeEvent("onAuthorizeLocationChange", "media.onAuthorizeLocationChange", callback, once);
}

/**
 * @supportContainer web | lynx
 */
function updateUserLocation(params, callback, options) {
    return core$1.pipeCall("updateUserLocation", "media.updateUserLocation", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function getLocationPermissionStatus(params, callback, options) {
    return core$1.pipeCall("getLocationPermissionStatus", "media.getLocationPermissionStatus", params, callback, options);
}

/**
 * @supportContainer web | lynx
 */
function toAuthorizeLocation(params, callback, options) {
    return core$1.pipeCall("toAuthorizeLocation", "media.toAuthorizeLocation", params, callback, options);
}



var media = /*#__PURE__*/Object.freeze({
	__proto__: null,
	imagesViewer: imagesViewer,
	onImageUploaded: onImageUploaded,
	cameraAuthorized: cameraAuthorized,
	openToolCamera: openToolCamera,
	albumAuthorized: albumAuthorized,
	openImageView: openImageView,
	openSettings: openSettings,
	onAuthorizeLocationChange: onAuthorizeLocationChange,
	updateUserLocation: updateUserLocation,
	getLocationPermissionStatus: getLocationPermissionStatus,
	toAuthorizeLocation: toAuthorizeLocation
});

/**
 * @supportContainer lynx
 */
function followPanel(params, callback, options) {
    return core$1.pipeCall("followPanel", "discover.followPanel", params, callback, options);
}

/**
 * @supportContainer lynx
 */
function bannerPosition(params, callback, options) {
    return core$1.pipeCall("bannerPosition", "discover.bannerPosition", params, callback, options);
}

/**
 * @supportContainer lynx
 */
function changeSeasons(params, callback, options) {
    return core$1.pipeCall("changeSeasons", "discover.changeSeasons", params, callback, options);
}



var discover = /*#__PURE__*/Object.freeze({
	__proto__: null,
	followPanel: followPanel,
	bannerPosition: bannerPosition,
	changeSeasons: changeSeasons
});

/**
 * @supportContainer web
 */
function setCampaignInfo(params, callback, options) {
    return core$1.pipeCall("setCampaignInfo", "activity.setCampaignInfo", params, callback, options);
}



var activity = /*#__PURE__*/Object.freeze({
	__proto__: null,
	setCampaignInfo: setCampaignInfo
});

/**
 * @description Global configuration function in Queqiao SDK
 * @param params.env After configuring env, the getRuntimeEnv method will no longer be used
 * @param params.context Configure context in method scope (Just need in lynx, use as follows: context: this)
 * @param params.disableLog Toggle inner log when the method is called
 * @param params.monitor Custom monitor function
 * @param params.onInvokeStart Custom function before calling
 * @param params.onInvokeEnd Custom function after the end of call
 * @param params.options Custom options
 */
function globalConfig(params) {
    core.globalConfig(params);
    core$1.globalConfig(params);
}
/**
 * The core jsbridge module in the SDK
 */
var bridge = core.bridge;
/**
 * Listen events from client
 */
var on = core.on.bind(core);
/**
 * Some utils from SDK
 */
var util$1 = {
    caniuse: core.caniuse.bind(core),
};

export { action, activity, albumAuthorized, app, articleDigg, bannerPosition, bottomToast, bridge, cameraAuthorized, changeSeasons, chooseImages, clearSearchResult, closeActivity, copyToClipboard, dialog, disableIOSWebViewFocusAutoScroll, discover, domReady, enterPublishPage, favorite, fetch, finishLoading, followPanel, followUser, geckoUpdate, getApiCommonParams, getAppInfo, getKeyboardHeight, getLocationPermissionStatus, getMediaInfo, getPushStatus, getResultList, getUserInfo, getUserSubscribe, globalConfig, goProfile, imagesViewer, inView, logFeedbackInfo, login, media, on, onAuthorizeLocationChange, onBackWillTrigger, onCloseSetUpProfile, onFavoriteChange, onFollowUserChange, onImageUploaded, onKeyboardDidHide, onKeyboardDidShow, onKeyboardWillHide, onKeyboardWillShow, onLikeArticleChange, onPageActivate, onScrollToArticle, onSearchLoadmore, onShareOperate, onSubscriptionChanged, onVisibleChange, open, openAlbum, openBrowser, openImageView, openSettings, openSystemPushPage, openToolCamera, outOfView, precreateKitView, prefetchImage, preventBack, preventScroll, removeWebViewLoading, saveArticles, saveImage, saveResultList, screenTimeUpdate, search, setCampaignInfo, setKeyboardVisible, setSkinData, setTitleVisible, setValueForKey, share, share2platform, shareImage, showLoading, snackbar, subscribe, toAuthorizeLocation, toast, trackEvents, updateUserLocation, uploadImage, uploadImageByPath, user, util$1 as util, valueForKey, vibration, view };
